import { useTranslation } from 'react-i18next'

import articlePlaceHolder from 'assets/images/home/cover_placeholder.png'
import { Loader } from 'components/Loader/Loader'
import { createdUpdatedAtShort } from 'helpers/date/created-updated-at-short'
import { useGetSectionsWithCategoryId } from 'pages/howTo/service/react-query/useGetSectionsWithId/useGetSectionsWithId'
import { useFilterAndSearchStore } from 'pages/howTo/store/filterAndSearch'

import { Accordion } from './components/Accordion/Accordion'
import { Card } from '../../common/Card/Card'

interface IFaqProps {
  id?: number
}

export const Faq = ({ id }: IFaqProps) => {
  const { t } = useTranslation()
  const { data: faqs, isLoading } = useGetSectionsWithCategoryId(id)
  const searchTerm = useFilterAndSearchStore(state => state.searchTerm.query.trim().toLowerCase())

  if (isLoading) return <Loader />

  const filteredFaqs = faqs?.data?.message?.map(section => {
    const filteredArticles = section.articles?.filter(article =>
      article.title.toLowerCase().includes(searchTerm)
    )
    return {
      ...section,
      articles: filteredArticles,
    }
  }).filter(section => section.articles?.length > 0)

  return (
    <>
      {searchTerm ? (
        <>
          {filteredFaqs?.length ? (
            filteredFaqs.flatMap(section =>
              section.articles.map(article => (
                <Card
                  key={article.id}
                  id={article.id}
                  type="faq"
                  sectionName={section.name}
                  title={article.title}
                  date={createdUpdatedAtShort(article.created_at)}
                  img={articlePlaceHolder}
                />
              ))
            )
          ) : (
            <span>{t('noResults')}</span>
          )}
        </>
      ) : (
        faqs?.data?.message?.map(faq => (
          <Accordion
            key={faq.id}
            sectionName={faq.name}
            items={faq.articles}
          />
        ))
      )}
    </>
  )
}
